import { Component, Input } from '@angular/core';

@Component({
  selector: 'lm-drawer-side-collapsed',
  standalone: false,
  template: '@if (collapsed) {<ng-content></ng-content>}',
  styleUrls: ['./lm-drawer-side-collapsed.component.scss']
})
export class LMDrawerSideCollapsedComponent {
  @Input() collapsed = false;
}
